import { render, staticRenderFns } from "./selectedTag.vue?vue&type=template&id=3feddcaa&scoped=true"
import script from "./selectedTag.vue?vue&type=script&lang=js"
export * from "./selectedTag.vue?vue&type=script&lang=js"
import style0 from "./selectedTag.vue?vue&type=style&index=0&id=3feddcaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feddcaa",
  null
  
)

export default component.exports